import React from 'react';
import PropTypes from 'prop-types';

import { MTableHeader, MTableActions } from 'material-table';
import LiveMaterialTable from 'common/components/LiveMaterialTable';
import AddIcon from '@material-ui/icons/LibraryAdd';
import WhatsAppIcon from '@material-ui/icons/PhoneIphone';
import ReplayIcon from '@material-ui/icons/Replay';
import CloseIcon from '@material-ui/icons/Close';
import { getColorState } from 'tasks/services/config/taskConfig';
import { calculateHeight } from 'common/services/util';
import { AttachFile, CheckBox, Description, Email, Gesture, Notifications, PhonePausedRounded, Print } from '@material-ui/icons';
import addInvoiceFromTaskUseCase from 'tasks/services/addInvoiceFromTaskUseCase';
import { FormControl, InputLabel, MenuItem, Menu, Select, Dialog, DialogTitle, DialogContent, IconButton, Tooltip, Badge } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ReceiptLongSvg from 'assets/icons/ReceiptLongSvg';
import TableTitle from 'common/components/TableTitle';
import { db } from 'common/config/Firebase';
import { ICON_MAP } from 'common/config/infoIconsConfig';

const TableTask = (
    {
        data,
        columns,
        loading,
        onTaskAdd,
        onTaskUpdate,
        onTaskDelete,
        onRowClick,
        onSendWhatsApp,
        onCreateInvoice,
        onCreateTicket,
        onCreateRMA,
        dateFilter,
        onDateFilterChange,
        onOrderChange,
        onSignTaskPriority,
        onColumnDrag,
        tableRefProp,
        getRowStyle,
        onSendEmail
    }) => {

    const [menuAnchor, setMenuAnchor] = React.useState(null);
    const [menuRow, setMenuRow] = React.useState(null);
    const [infoIcons, setInfoIcons] = React.useState([]);
    const [openInfoItem, setOpenInfoItem] = React.useState(null);

    React.useEffect(() => {
        const unsub = db.collection('meta').doc('settings').onSnapshot(snap => {
            if (snap.exists) {
                setInfoIcons(snap.data().infoIcons || []);
            }
        });
        return () => unsub();
    }, []);

    const openMenu = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setMenuRow(row);
    };
    const closeMenu = () => setMenuAnchor(null);

    const [whatsappAnchor, setWhatsappAnchor] = React.useState(null);
    const [whatsappRow, setWhatsappRow] = React.useState(null);

    const openWhatsappMenu = (event, row) => {
        setWhatsappAnchor(event.currentTarget);
        setWhatsappRow(row);
    };
    const closeWhatsappMenu = () => setWhatsappAnchor(null);

    const [emailAnchor, setEmailAnchor] = React.useState(null);
    const [emailRow, setEmailRow] = React.useState(null);

    const openEmailMenu = (event, row) => {
        setEmailAnchor(event.currentTarget);
        setEmailRow(row);
    };
    const closeEmailMenu = () => setEmailAnchor(null);

    const visibleInfoIcons = React.useMemo(
        () => infoIcons.filter(item => item.icon && item.imageUrl),
        [infoIcons]
    );

    const ActionsComponent = React.useMemo(() => {
        return props => {
            const hasFreeActions = props.actions && props.actions.some(a => {
                const action = typeof a === 'function' ? a(props.data) : a;
                return action && action.isFreeAction;
            });
            if (!hasFreeActions) {
                return <MTableActions {...props} />;
            }
            return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MTableActions {...props} />
                    {visibleInfoIcons.length > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 16, borderLeft: '1px solid #e0e0e0', paddingLeft: 16 }}>
                            {visibleInfoIcons.map((item, i) => {
                                const Ic = ICON_MAP[item.icon];
                                if (!Ic) return null;
                                return (
                                    <Tooltip key={i} title={item.title || ''} arrow>
                                        <IconButton
                                            size="small"
                                            onClick={() => setOpenInfoItem(item)}
                                            style={{ color: '#3f51b5', padding: '8px' }}
                                        >
                                            <Ic />
                                        </IconButton>
                                    </Tooltip>
                                );
                            })}
                        </div>
                    )}
                </div>
            );
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleInfoIcons]);


    const onColumnDragged = () => {
        const currentColumns = tableRefProp.current.dataManager.columns;
        onColumnDrag(currentColumns)
    }

    return (
        <div className="stateful-table">
            <LiveMaterialTable
                title={<TableTitle>Reparaciones</TableTitle>}
                tableRef={tableRefProp}
                icons={{
                    'Add': () => <AddIcon fontSize='large' color='primary'></AddIcon>
                }}
                columns={columns}
                data={data}
                isLoading={loading}
                options={{
                    search: false,
                    sorting: true,
                    actionsColumnIndex: 1,
                    filtering: true,
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    rowStyle: (rowData, index) => getRowStyle(rowData, index)
                }}
                components={{
                    Actions: ActionsComponent
                }}
                actions={[
                    (rowData) => ({
                    icon: () => (
                        <Badge
                            badgeContent={rowData.notifyReparado || rowData.notifyPresupuesto ? <Notifications style={{ fontSize: 13, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /> : null}
                            style={{ fontSize: 11 }}
                        >
                            <WhatsAppIcon />
                        </Badge>
                    ),
                    tooltip: 'Enviar whatsapp',
                    onClick: (e, r) => openWhatsappMenu(e, r)
                    }),
                    (rowData) => ({
                    icon: () => (
                        <Badge
                            badgeContent={rowData.notifyReparado || rowData.notifyPresupuesto ? <Notifications style={{ fontSize: 13, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /> : null}
                            style={{ fontSize: 11 }}
                        >
                            <Email />
                        </Badge>
                    ),
                    tooltip: 'Enviar correo',
                    onClick: (e, r) => openEmailMenu(e, r)
                    }),
                    {
                    icon: () => <Print />,
                    tooltip: 'Imprimir tarea',
                    onClick: (e, r) => onRowClick(r)
                    },
                    {
                    icon: () => <ReceiptLongSvg />,
                    tooltip: 'Crear ticket',
                    onClick: (e, r) => onCreateTicket({ data: r })
                    },
                    {
                    icon: () => <MoreVertIcon />,
                    tooltip: 'Más acciones',
                    onClick: (e, r) => openMenu(e, r)
                    },
                    {
                    icon: () => (
                        <FormControl style={{ minWidth: '100px' }}>
                        <InputLabel htmlFor="age-native-simple">Fecha</InputLabel>
                        <Select value={dateFilter} onChange={ev => onDateFilterChange(ev.target.value)}>
                            <MenuItem value={0}>3 meses</MenuItem>
                            <MenuItem value={1}>6 meses</MenuItem>
                            <MenuItem value={2}>1 año</MenuItem>
                            <MenuItem value={3}>Todos</MenuItem>
                        </Select>
                        </FormControl>
                    ),
                    isFreeAction: true
                    }
                ]}
                editable={{
                    onRowAdd: onTaskAdd,
                    onRowUpdate: onTaskUpdate,
                    onRowDelete: onTaskDelete
                }}
                onOrderChange={() => onOrderChange()}
                onColumnDragged={onColumnDragged}
                localization={{
                    body: {
                        editRow: {
                            deleteText: '¿Seguro que quieres eliminar esta tarea?',
                            cancelTooltip: 'Cancelar'
                        },
                        addTooltip: 'Añadir tarea',
                        deleteTooltip: 'Eliminar',
                        emptyDataSourceMessage: 'No hay registros para mostrar'
                    },
                    toolbar: {
                        searchTooltip: 'Buscar',
                        searchPlaceholder: 'Buscar'
                    },
                    header: {
                        actions: 'Acciones'
                    },
                    pagination: {
                        labelRowsSelect: 'filas',
                        labelDisplayedRows: '{from}-{to} de {count}',
                        firstTooltip: 'Primera página',
                        previousTooltip: 'Anterior',
                        nextTooltip: 'Siguiente',
                        lastTooltip: 'Última página'
                    }
                }}
            />
            <Dialog
                open={!!openInfoItem}
                onClose={() => setOpenInfoItem(null)}
                maxWidth={false}
                fullScreen
            >
                <IconButton
                    onClick={() => setOpenInfoItem(null)}
                    style={{ position: 'absolute', top: 8, right: 8, zIndex: 1, color: '#fff', backgroundColor: 'rgba(0,0,0,0.4)' }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogTitle style={{ paddingRight: 56 }}>
                    {openInfoItem?.title}
                </DialogTitle>
                <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 8 }}>
                    {openInfoItem?.imageUrl && (
                        <img
                            src={openInfoItem.imageUrl}
                            alt={openInfoItem?.title || ''}
                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                    )}
                </DialogContent>
            </Dialog>

            <Menu
                anchorEl={emailAnchor}
                open={Boolean(emailAnchor)}
                onClose={closeEmailMenu}
                keepMounted
            >
                <MenuItem onClick={() => { onSendEmail(emailRow, 'recepcion'); closeEmailMenu(); }}>
                    <Email style={{ marginRight: 8 }} fontSize="small" />
                    Recepción
                </MenuItem>
                <MenuItem onClick={() => { onSendEmail(emailRow, 'reparado'); closeEmailMenu(); }}
                    style={emailRow?.notifyReparado ? { color: '#c0392b', fontWeight: 600 } : {}}>
                    <Email style={{ marginRight: 8 }} fontSize="small" />
                    {emailRow?.notifyReparado ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reparado <Notifications style={{ fontSize: 16, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /></span> : 'Reparado'}
                </MenuItem>
                <MenuItem onClick={() => { onSendEmail(emailRow, 'sin_reparar'); closeEmailMenu(); }}>
                    <Email style={{ marginRight: 8 }} fontSize="small" />
                    Sin reparar
                </MenuItem>
                <MenuItem onClick={() => { onSendEmail(emailRow, 'informe'); closeEmailMenu(); }}
                    style={emailRow?.notifyPresupuesto ? { color: '#c0392b', fontWeight: 600 } : {}}>
                    <Email style={{ marginRight: 8 }} fontSize="small" />
                    {emailRow?.notifyPresupuesto ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Informe <Notifications style={{ fontSize: 16, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /></span> : 'Informe'}
                </MenuItem>
            </Menu>
            <Menu
                anchorEl={whatsappAnchor}
                open={Boolean(whatsappAnchor)}
                onClose={closeWhatsappMenu}
                keepMounted
            >
                <MenuItem onClick={() => { onSendWhatsApp(whatsappRow, 'reparado'); closeWhatsappMenu(); }}
                    style={whatsappRow?.notifyReparado ? { color: '#c0392b', fontWeight: 600 } : {}}>
                    <WhatsAppIcon style={{ marginRight: 8 }} fontSize="small" />
                    {whatsappRow?.notifyReparado ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reparado <Notifications style={{ fontSize: 16, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /></span> : 'Reparado'}
                </MenuItem>
                <MenuItem onClick={() => { onSendWhatsApp(whatsappRow, 'sin_reparar'); closeWhatsappMenu(); }}>
                    <WhatsAppIcon style={{ marginRight: 8 }} fontSize="small" />
                    Sin reparar
                </MenuItem>
                <MenuItem onClick={() => { onSendWhatsApp(whatsappRow, 'presupuesto'); closeWhatsappMenu(); }}
                    style={whatsappRow?.notifyPresupuesto ? { color: '#c0392b', fontWeight: 600 } : {}}>
                    <WhatsAppIcon style={{ marginRight: 8 }} fontSize="small" />
                    {whatsappRow?.notifyPresupuesto ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Presupuesto <Notifications style={{ fontSize: 16, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} /></span> : 'Presupuesto'}
                </MenuItem>
                <MenuItem onClick={() => { onSendWhatsApp(whatsappRow, 'informe'); closeWhatsappMenu(); }}>
                    <WhatsAppIcon style={{ marginRight: 8 }} fontSize="small" />
                    Informe
                </MenuItem>
                <MenuItem onClick={() => { onSendWhatsApp(whatsappRow, 'general'); closeWhatsappMenu(); }}>
                    <WhatsAppIcon style={{ marginRight: 8 }} fontSize="small" />
                    General
                </MenuItem>
            </Menu>
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={closeMenu}
                keepMounted
                >
                <MenuItem onClick={() => { onSignTaskPriority(menuRow); closeMenu(); }}>
                    <Gesture style={{ marginRight: 8 }} fontSize="small" />
                    Firmar tarea
                </MenuItem>

                <MenuItem onClick={() => { onCreateInvoice({ data: menuRow }); closeMenu(); }}>
                    <Description style={{ marginRight: 8 }} fontSize="small" />
                    Crear factura
                </MenuItem>

                <MenuItem onClick={() => { onCreateRMA({ data: menuRow }); closeMenu(); }}>
                    <ReplayIcon style={{ marginRight: 8 }} fontSize="small" />
                    Crear reincidencia
                </MenuItem>
            </Menu>
        </div>
    );
};

TableTask.propTypes = {
    data: PropTypes.array,
    onTaskAdd: PropTypes.func.isRequired,
    onTaskUpdate: PropTypes.func.isRequired,
    onTaskDelete: PropTypes.func.isRequired,
    onCreateRMA: PropTypes.func,
};

export default React.forwardRef(TableTask);
